<div class="login-bg">
  <div class="login-card">
    <div class="login-logo">
      <img [src]="logoSrc" alt="Logo" />
    </div>

    <form (ngSubmit)="login()" class="login-form">
      <div class="form-group">
        <label for="username">{{ 'LOGIN.USERNAME_LABEL' | translate }}</label>
        <input id="username" type="text" [(ngModel)]="username" name="username"
          [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate" required />
      </div>
      <div class="form-group">
        <label for="password">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
        <div class="password-wrapper">
          <input id="password" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" name="password"
            [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate" required />
          <button type="button" class="show-password" (click)="togglePassword()" tabindex="-1">
            <fa-icon [icon]="showPassword ? faEye : faEyeSlash"></fa-icon>
          </button>
        </div>
      </div>
      <button class="login-btn" type="submit" [disabled]="!username || !password || loading">
        @if (loading) {
        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
        } @else {
        {{ 'LOGIN.BUTTON' | translate }}
        }
      </button>
      @if (error) {
      <div class="error">{{ error }}</div>
      }
      <div class="login-footer">
        <small>
           © Copyright Di2win {{ year }} - {{ 'LOGIN.FOOTER' | translate }}
        </small>
      </div>
    </form>
  </div>
</div>